import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/lucide-react@1.63.0_@types+react@19.3.0_react@19.3.1/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@24.19.2_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CategorySwitcher"] */ "/app/src/app/[locale]/(main)/categories/[slug]/_modules/category-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductsPageClient"] */ "/app/src/app/[locale]/(main)/products/products-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkWithChannel"] */ "/app/src/ui/atoms/link-with-channel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RetailReferralLink"] */ "/app/src/ui/components/commerce/retail-referral-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewportDeferredDecorativeVideo"] */ "/app/src/ui/components/marketing/deferred-decorative-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilterChips"] */ "/app/src/ui/components/peptide/filter-chips.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PeptideProductCard"] */ "/app/src/ui/components/peptide/peptide-product-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilterBar"] */ "/app/src/ui/components/plp/filter-bar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/plp/product-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useProductFilters"] */ "/app/src/ui/components/plp/use-product-filters.ts");
